import {
  BooleanSetting,
  useUserSetting,
} from "shared-ts-utils-user-settings";

export const useConsentToMonitorIssues = () => {
  return useUserSetting<boolean>("consentToMonitorIssues", BooleanSetting);
};
